export default __webpack_public_path__ + "static/media/big-coins.56456849.png";